'use strict';

exports.__esModule = true;
exports.falsy = falsy;

var _propTypes = require('prop-types');

function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

var history = _propTypes.shape({
  listen: _propTypes.func.isRequired,
  pushState: _propTypes.func.isRequired,
  replaceState: _propTypes.func.isRequired,
  go: _propTypes.func.isRequired
});

exports.history = history;
var location = _propTypes.shape({
  pathname: _propTypes.string.isRequired,
  search: _propTypes.string.isRequired,
  state: _propTypes.object,
  action: _propTypes.string.isRequired,
  key: _propTypes.string
});

exports.location = location;
var component = _propTypes.oneOfType([_propTypes.func, _propTypes.string]);
exports.component = component;
var components = _propTypes.oneOfType([component, _propTypes.object]);
exports.components = components;
var route = _propTypes.oneOfType([_propTypes.object, _propTypes.element]);
exports.route = route;
var routes = _propTypes.oneOfType([route, _propTypes.arrayOf(route)]);

exports.routes = routes;
exports['default'] = {
  falsy: falsy,
  history: history,
  location: location,
  component: component,
  components: components,
  route: route
};